import { ITheme } from "@corvina/corvina-app-connect/dist/ITheme";

function setConnectThemeIntoVuetifyLightTheme(
  connectTheme: ITheme,
  vuetifyColors: any
) {
  vuetifyColors.primary = connectTheme.colors.primary;
  vuetifyColors.secondary = connectTheme.colors.highlight;
  vuetifyColors.success = connectTheme.colors.good;
  vuetifyColors.info = connectTheme.colors.alert;
  vuetifyColors.warning = connectTheme.colors.warningMild;
  vuetifyColors.error = connectTheme.colors.warningSerious;

  document.documentElement.style.setProperty(
    "--color-primary",
    connectTheme.colors.primary
  );
  document.documentElement.style.setProperty(
    "--color-primary-dk1",
    connectTheme.colors.primaryDk1
  );
  document.documentElement.style.setProperty(
    "--color-primary-dk2",
    connectTheme.colors.primaryDk2
  );
  document.documentElement.style.setProperty(
    "--color-primary-g1",
    connectTheme.colors.g1
  );
  document.documentElement.style.setProperty(
    "--color-primary-g2",
    connectTheme.colors.g2
  );
  document.documentElement.style.setProperty(
    "--color-primary-g3",
    connectTheme.colors.g3
  );
  document.documentElement.style.setProperty(
    "--color-primary-g4",
    connectTheme.colors.g4
  );
  document.documentElement.style.setProperty(
    "--color-highlight",
    connectTheme.colors.highlight
  );
  document.documentElement.style.setProperty(
    "--color-alert",
    connectTheme.colors.alert
  );
  document.documentElement.style.setProperty(
    "--color-warning-serious",
    connectTheme.colors.warningSerious
  );
  document.documentElement.style.setProperty(
    "--color-warning-mild",
    connectTheme.colors.warningMild
  );
  document.documentElement.style.setProperty(
    "--color-good",
    connectTheme.colors.good
  );
}

export { setConnectThemeIntoVuetifyLightTheme };
